import request from '@/utils/request'


// 列表
export function listPage(data) {
  return request({
    url: 'admin/data/contingencyplan/list',
    method: 'post',
    data
  })
}
// 列表
export function compListPage(data) {
  return request({
    url: 'admin/data/contingencyplancomp/list',
    method: 'post',
    data
  })
}
// 下一个书签
export function nextBookmark(data) {
  return request({
    url: 'admin/data/contingencyplan/nextBookmark',
    method: 'post',
    data
  })
}

// 上一个书签
export function previousBookmark(data) {
  return request({
    url: 'admin/data/contingencyplan/previousBookmark',
    method: 'post',
    data
  })
}

// 添加书签
export function addBookmark(data) {
  return request({
    url: 'admin/data/contingencyplan/addBookmark',
    method: 'post',
    data
  })
}

// 删除书签
export function delBookmark(data) {
  return request({
    url: 'admin/data/contingencyplan/delBookmark',
    method: 'post',
    data
  })
}

// 删除预案
export function deleteHandle(data) {
  return request({
    url: 'admin/data/contingencyplan/del',
    method: 'post',
    data
  })
}
// 删除预案
export function compDeleteHandle(data) {
  return request({
    url: 'admin/data/contingencyplancomp/del',
    method: 'post',
    data
  })
}

// 下拉信息初始化
export function addSelectInit() {
  return request({
    url: 'admin/data/contingencyplan/init',
    method: 'get'
  })
}

// 详情
export function info(id) {
  return request({
    url: 'admin/data/contingencyplan/info/' + id,
    method: 'get'
  })
}
// 详情
export function compInfo(id) {
  return request({
    url: 'admin/data/contingencyplancomp/info/' + id,
    method: 'get'
  })
}

// 添加应急预案
export function insertUpdatePlan(data) {
  return request({
    url: 'admin/data/contingencyplan/insertUpdatePlan',
    method: 'post',
    data
  })
}
// 导入
export function importData(data) {
  return request({
    url: 'admin/data/contingencyplan/importData',
    method: 'post',
    data
  })
}

export function getDownloadFile(data) {
  return request({
    url: 'admin/data/contingencyplan/downloadFile',
    method: 'post',
    data
  })
}